import { PublicationsFormService } from './shared/publications.form.service';
import { PublicationsDataService } from './shared/publications.data.service';
import { Component, OnInit, Input, Output, ViewChild, TemplateRef, OnChanges, SimpleChanges } from '@angular/core';
import { BaseControl, Boletines, ConfirmComponent, Publicacion, Const } from '@app/shared';
import { FormGroup } from '@angular/forms';
import { PublicationsConfigService } from './shared/publications.config.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService, Logger } from '@app/core';
import { last } from 'lodash';
import { DatePipe } from '@angular/common';

const log = new Logger('PublicationsComponent');

@Component({
  selector: 'iw-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.scss'],
  providers: [
    PublicationsDataService,
    PublicationsFormService,
    DatePipe
  ]
})
export class PublicationsComponent implements OnInit, OnChanges {
  // 
  allBulletins: Boletines[] = [];

  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Referencia del formulario
  form: FormGroup;
  // configuraciones de la tabla
  settings = {};
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false
  };
  // Contiene el formulario de envio para guardar o modificar una publicacion
  formData: FormData = new FormData();
  // Datos para llenar la tabla
  sourceData: Publicacion[] = [];
  // Contiene los controles de el formulario de pubblicaciones
  controls: BaseControl<any>[] = [];
  // Variable que valida los tipos de documentos que se pueden subir
  extensions: string[] = ['docx', 'doc'];
  // Define si la publicacion en accion es para editar
  publicacionEdit = true;
  // Define si la publicacion en accion es para editar
  publicacionSelected: Publicacion;
  // id del boletin seleccionado
  private _bulletinSelect: any;
  // contiene la fila selleccionada
  selectedRows: any;
  // Referencia a la plantilla para el control personalizado de cargar documento
  @ViewChild('fileUpload') fileUpload: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // entrada con el listado de todos los boletines
  @Input() bulletins: Boletines[];

  constructor(
    private toastr: ToastrService,
    private as: AuthenticationService,
    private pds: PublicationsDataService,
    private pdfs: PublicationsFormService,
    private datePipe: DatePipe
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.loadPublicaciones();
  }

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationPublications,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationPublications,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationPublications,
      Const.types_action_permissions.delete
    );
    const configTable = new PublicationsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
      switch (res.action) {
        case 'descargar':
          this.downloadDocument(res.data);
          break;
      }
    });
  }


  /**
   * consulta las publicaciones por el id del boletin
   *
   * @memberof PublicationsComponent
   */
  loadPublicaciones() {
    log.debug(this.bulletins);
    if (this.idBulletinSelect) {
      this.pds.getPublicaciones(this.idBulletinSelect).subscribe(res => {
        this.sourceData = res;
      });
      this.pds.getBulletins().subscribe(res => {
        this.allBulletins = res;
      });
    }
  }

  /**
   * contiene los rows seleccionados
   *
   * @param {*} event
   * @memberof PublicationsComponent
   */
  onRowSelect(event: any) {
    this.selectedRows = event.selected;
  }

  /**
   * Metodo que realiza la publicacion masiva
   *
   * @return {*}
   * @memberof PublicationsComponent
   */
  async publishMassively() {
    let publications: number[] = [];
    this.selectedRows.forEach((e: Publicacion) => {
      if (!e.publicado) {
        publications.push(e.id);
      }
    });
    if (this.activateAction.created && publications.length > 0) {
      this.publicacionEdit = false;
      const res = await this.pds.publishMassively(publications);
      if (res) {
        this.loadPublicaciones();
      }
    } else {
      if (publications.length === 0) {
        this.toastr.warning('Los documentos seleccionados ya han sido publicados',
        'Advertencia');
        this.loadPublicaciones();
      } else {
      this.toastr.error('Usted no posee permisos para agregar clasificaciones del sistema',
        'Permiso denegado');
      }
    }
    this.selectedRows = [];
  }

  set idBulletinSelect(value: any) {
    if (value !== this.idBulletinSelect) {
      this._bulletinSelect = value;
      this.loadPublicaciones();
    }
  }

  get idBulletinSelect(): any {
    return this._bulletinSelect;
  }


  /**
   * Define las acciones ha realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof PublicationsComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'update':
        if (this.activateAction.update) {
          this.formOpen = true;
          this.publicacionEdit = true;
          this.actionForm = 'Modificar';
          this.publicacionSelected = data;
          this.controls = this.pdfs.getFormPubblication(this.fileUpload, this.publicacionSelected);
        } else {
          this.toastr.error('Usted no posee permisos para modificar clasificaciones del sistema',
            'Permiso denegado');
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.publicacionSelected = data;
          this.question = '¿Realmente desea eliminar la clasificación documental?';
          this.confirm.open();
        } else {
          this.toastr.error('Usted no posee permisos para eliminar clasificaciones del sistema',
            'Permiso denegado');
        }
        break;
    }
  }


  /**
   * Metodo que organiza el formData y modifica una publicacion
   *
   * @memberof PublicationsComponent
   */
  sended() {
    if (this.form.valid) {
      this.formData.append('asunto', this.form.controls['asunto'].value);
      this.formData.append('publicado', this.form.controls['publicado'].value ? 'True' : 'False');
      this.formData.append('fecha_publicacion',
      this.datePipe.transform(this.form.controls['fecha_publicacion'].value, 'yyyy-MM-dd'));
      if (this.publicacionSelected) {
        this.pds.updatePublicaction(
          this.publicacionSelected.id,
          this.formData
        ).then(() => {
          this.closeForm();
          this.loadPublicaciones();
        });
      }
    }
  }

  /**
   * Valida el documento y emite la acción de descargar el documento
   *
   * @private
   * @param {number} data
   * @return {*}  {*}
   * @memberof PublicationsComponent
   */
  private downloadDocument(data: any): any {
    this.pds.dowloadFilePublicaction(data.id_documento_historial).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }



  /**
   * Agregar o remover un documento
   *
   * @param {*} data
   * @return {*}  {*}
   * @memberof PublicationsComponent
   */
  onAction(data: any,): any {
    if (data.action === 1) {
      this.onAdded(data);
    } else if (data.action === 0) {
      this.onRemoved();
    }
  }



  /**
   * Controla el evento de cargar un documento
   *
   * @private
   * @param {*} data
   * @return {*}  {*}
   * @memberof PublicationsComponent
   */
  private onAdded(data: any): any {
    this.formData.append('documento', data.file);
  }


  /**
   * Controla el evento de remover un documento cargado
   *
   * @private
   * @return {*}  {*}
   * @memberof PublicationsComponent
   */
  private onRemoved(): any {
    this.formData.delete('plantilla_generacion');
  }



  /**
   * Elimina una publicacion
   *
   * @private
   * @memberof PublicationsComponent
   */
  private deletePublicacion() {
    this.pds.deletePublicaction(this.publicacionSelected.id).then(() => {
      this.closeForm();
      this.loadPublicaciones();
    }).catch(() => {
      this.closeForm();
    });
  }



  /**
   * Cierra la vista del formulario de creacion o edicion
   *
   * @memberof PublicationsComponent
   */
  closeForm() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.publicacionEdit = false;
    this.publicacionSelected = null;
    this.formData = new FormData();
  }


  /**
   * Activa modal de confirmación
   *
   * @param {boolean} res
   * @memberof PublicationsComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deletePublicacion();
    }
    this.question = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/publications/publications.component.ts